<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  appointments: { type: Array, default: () => [] },
});
const emit = defineEmits(['open-appointment']);

const store = useStore();
const { t } = useI18n();

const statusFilter = computed(
  () => store.getters['painelView/getStatusFilter']
);

const filteredAppointments = computed(() =>
  props.appointments.filter(a => statusFilter.value.has(a.status))
);

const formatHour = ts =>
  new Date(ts).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
</script>

<template>
  <div class="flex flex-1 flex-col overflow-y-auto">
    <div class="flex flex-col gap-2 p-6">
      <button
        v-for="appt in filteredAppointments"
        :key="appt.id"
        type="button"
        class="w-full rounded-lg border border-n-strong bg-n-surface-2 p-3 text-left text-sm hover:bg-n-slate-3"
        @click="emit('open-appointment', appt)"
      >
        <div class="font-medium text-n-slate-12">
          {{ appt.contact?.name || appt.title || '—' }}
        </div>
        <div class="text-xs text-n-slate-11">
          {{ formatHour(appt.starts_at) }} &#x2013;
          {{ formatHour(appt.ends_at) }}
        </div>
      </button>
      <div
        v-if="filteredAppointments.length === 0"
        class="py-12 text-center text-n-slate-10"
      >
        {{ t('PAINEL.APPOINTMENTS.EMPTY_DAY') }}
      </div>
    </div>
  </div>
</template>
